import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { ProgressBar } from "primereact/progressbar";
import ActionCards from "./actionCards";
import { userAllocationService, attendanceApi, Util } from "../../services";
import { LEAVES_MENU_VIEW } from '../../config/permissions';
import { hasPermission } from "../../components/protected/ProtectedSection";
import moment from "moment";
import { confirmDialog } from 'primereact/confirmdialog';
import { toast } from "react-toastify";
import { Dialog } from 'primereact/dialog';
import { useFormik } from "formik";
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { regularizationReason, workingHours } from "../../common/util/constants";
import { classNames } from 'primereact/utils';
import { useSelector } from "react-redux";

const PROJ_STATUS = ["pending", "ongoing", "upcoming"];
const EmployeeDashboard = ({ setNewAlloc }) => {
  const { user } = useSelector(state => state.user);
  const navigate = useNavigate();
  const [allocations, setAllocations] = useState([]);
  const [ongoingProject, setOngoingProject] = useState([]);
  const [upcomingProject, setUpcomingProject] = useState([]);
  const [totalWorkingHour, setTotalWorkingHour] = useState(8);
  const [empActionList, setEmpActionList] = useState([]);
  const [missingUserAttendanceList, setMissingUserAttendanceList] = useState([]);
  const [showNewForm1, setShowNewForm] = useState(false);
  const [checkedBox, setCheckedBox] = useState(false);
  const [weekOffCheckedBox, setWeekOffCheckedBox] = useState(false);
  const [compOffCheckedBox, setcompOffCheckedBox] = useState(false);
  const [missingLeaveDate, setMissingLeaveDate] = useState();
  const officeOrHome = [
    { label: 'Office', code: 'WFO' },
    { label: 'Home', code: 'WFH' },
  ];
  const yourDropdownOptionsArray = [
    { label: regularizationReason.MARKOUT_FORGOT, value: regularizationReason.MARKOUT_FORGOT },
    { label: regularizationReason.REFILL_ATTENDANCE, value: regularizationReason.REFILL_ATTENDANCE }
  ];
  let count = 0;

  useEffect(() => {
    if (count === 0) {
      allocation_detail();
      getEmployeeAction();
      fetchMissingUserAttendance();
      count++;
    }
  }, []);

  const fetchMissingUserAttendance = () => {
    attendanceApi.missingAttendance({}).then((resp) => {
      setMissingUserAttendanceList(resp.data.leaveDay)
    });
  }

  const allocation_detail = (data) => {
    userAllocationService.createUserAllocation(data).then((resp) => {
      setAllocations(resp.data.data);
      let ongoingArr = resp.data.data.filter((el) => {
        return el.status === 1;
      });
      setOngoingProject(ongoingArr);
      let upcomingArr = resp.data.data.filter((el) => {
        return (el.status !== 1 && el.status !== 2 && el.status !== 4);
      });
      setUpcomingProject(upcomingArr);
    });
  };

  const getEmployeeAction = () => {
    userAllocationService.getEmpAction().then((resp) => {
      setEmpActionList(resp.data.data);
    });
  };

  const OngoingAllocation = () => {
    return (
      <div className="grid project-card mt-0">
        {ongoingProject.map((data, index) => {
          return (
            <div key={'oal-' + index} className={"col-6 project-" + PROJ_STATUS[data.status]}>
              <div className="grid">
                <div className="icon">
                  {data.icon == null ? (
                    <span>{data?.Project?.title.substr(0, 1)}</span>
                  ) : (
                    <img src={data.icon} />
                  )}
                </div>
                <div className="col">
                  <div className="project-name">
                    <h3>{data.Project.title}</h3>
                    {data.Project.projectType && (
                      <p><small>{data.Project.projectType ? data.Project.projectType : ''}{data.Project.projectGroup ? "-" + data.Project.projectGroup : ''}</small></p>
                    )}
                    <small>
                      {data.startDate} - {data.endDate} <br />
                      {data.isBillable === true ? (
                        <small style={{ color: "green" }}>Billable</small>
                      ) : (
                        <small style={{ color: "red" }}>Non-Billable</small>
                      )}
                    </small>
                  </div>
                </div>
              </div>
              <div className={"perc p-3 pt-0 project-status"}>
                <div className="grid">
                  <div className="col project-status-text">
                    <small>
                      <strong>
                        Allocation{" "}
                        {data.status === 1 ? "Now" : PROJ_STATUS[data.status]}
                      </strong>
                    </small>
                  </div>
                  <div className="col project-perc">
                    {data.percentage == 0 ? (
                      <span>
                        <strong>{data.hour} hrs</strong>
                      </span>
                    ) : (
                      <strong>{data.percentage} %</strong>
                    )}
                  </div>
                </div>
                <ProgressBar
                  value={
                    data.percentage == 0
                      ? (data.hour / totalWorkingHour) * 100
                      : data.percentage
                  }
                  showValue={false}
                ></ProgressBar>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const UpcomingAllocation = () => {
    return (
      upcomingProject.length ?
        <div className="grid project-card mt-0">
          {upcomingProject.map((data) => {
            return (
              <div className={"col-6 project-" + PROJ_STATUS[data.status]}>
                <div className="grid">
                  <div className="icon">
                    {data.icon == null ? (
                      <span>{data.Project.title.substr(0, 1)}</span>
                    ) : (
                      <img src={data.icon} />
                    )}
                  </div>
                  <div className="col">
                    <div className="project-name">
                      <h3>{data.Project.title}</h3>
                      <small>
                        {data.startDate} - {data.endDate}
                        <br />
                        {data.isBillable === true ? (
                          <small style={{ color: "green" }}>Billable</small>
                        ) : (
                          <small style={{ color: "red" }}>Non-Billable</small>
                        )}
                      </small>
                    </div>
                  </div>
                </div>
                <div className={"perc p-3 pt-0 project-status"}>
                  <div className="grid">
                    <div className="col project-status-text">
                      <small>
                        <strong>
                          Allocation{" "}
                          {data.status === 1 ? "Now" : PROJ_STATUS[data.status]}
                        </strong>
                      </small>
                    </div>
                    <div className="col project-perc">
                      {data.percentage === 0 ? (
                        <span>
                          <strong>{data.hour} hrs</strong>
                        </span>
                      ) : (
                        <strong>{data.percentage} %</strong>
                      )}
                    </div>
                  </div>
                  <ProgressBar
                    value={
                      data.percentage === 0
                        ? (data.hour / totalWorkingHour) * 100
                        : data.percentage
                    }
                    showValue={false}
                  ></ProgressBar>
                </div>
              </div>
            );
          })}
        </div> :
        <div><strong>You have No Upcoming Projects!</strong></div>
    );
  };

  const lmsForm = (ld) => {
    try {
      let attendanceDate = { leaveDay: ld, leaveDays: ld }
      localStorage.setItem("absenceData", JSON.stringify(attendanceDate));
      setTimeout(() => {
        navigate("/leaves/new-absence");
      }, 2000)
      navigate("/leaves");
    } catch (error) {
      localStorage.removeItem("absenceData")
    }
  };

  const attendanceForm = () => {
    setShowNewForm(true);
  };

  const applyMissingLeaveAttendance = (missingData) => {
    setMissingLeaveDate(missingData);
    confirmDialog({
      message: (
        <p>
          Were you on leave on <strong style={{ color: 'red' }}>{missingData}</strong>?
          <br /><br />
          Click <strong style={{ color: 'green' }}>YES</strong> if you were on personal or approved leave.
          <br />
          Click <strong style={{ color: 'red' }}>NO</strong> if it was a Client Holiday, Week Off, or Comp Off. Please raise a regularization request with your manager.
        </p>
      ),
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      accept: () => {
        try {
          if (hasPermission(LEAVES_MENU_VIEW)) {
            lmsForm(missingData);
          } else {
            const date = new Date(missingData);
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            let obj = {
              date: Util.dateConverterForAttendance(date),
              outDate: Util.dateConverterForAttendance(date),
              inTime: date,
              outTime: date,
              comments: 'Leave',
              location: 'LH',
              isOnLeave: true,
            };
            attendanceApi.createAttendanceRequest(obj).then(resp => {
              if (resp.data.success === true) {
                toast.success("Leave applied on ESS for " + missingData + ". Please apply on LMS")
                fetchMissingUserAttendance();
              }
              else {
                toast.error(resp.data.error);
              }
            });
          }
        } catch (error) {
          console.log(error, "Error on confirm dialog")
        }
      },

      reject: () => {
        attendanceForm()
      },
      // onHide: setChecked(false)
    });
  }

  const formik = useFormik({
    initialValues: {
      inTime: '',
      outTime: '',
      date: null,
      reason: null,
      attachment: null,
      location: ''
    },
    validate: (data) => {
      let errors = {};
      if (!checkedBox && !weekOffCheckedBox && !compOffCheckedBox) {
        if (!data.inTime) {
          errors.inTime = 'In Time is required.';
        }

        if (!data.outTime) {
          errors.outTime = 'Out Time is required.';
        }

        if (!data.reason) {
          errors.reason = 'Reason is required';
        }
        if (!data.location) {
          errors.location = 'Location is required';
        }
      }
      return errors;
    },
    onSubmit: (data) => {
      data.date = moment(missingLeaveDate, "DD-MM-YYYY").format("YYYY-MM-DD");
      createMissingAttendance(data);
    }
  });
  const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
  };

  const createMissingAttendance = (data) => {
    const date = new Date(data.date);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    let reqDate = Util.dateConverterForAttendance(data.date);
    let reqInTime = Util.getTimeWithTimezone(data.inTime);
    let reqOutTime = Util.getTimeWithTimezone(data.outTime);
    let obj = {
      date: Util.dateConverterForAttendance(data.date),
      outDate: Util.dateConverterForAttendance(data.date),
      inTime: weekOffCheckedBox ? date : checkedBox ? date : compOffCheckedBox ? date : Util.convertTZ(reqDate, reqInTime),
      outTime: weekOffCheckedBox ? date : checkedBox ? date : compOffCheckedBox ? date : Util.convertTZ(reqDate, reqOutTime),
      reason: weekOffCheckedBox ? 'Week Off' : checkedBox ? 'Client Holiday' : compOffCheckedBox ? 'Comp Off' : data.reason,
      innTime: Util.convertTZ(reqDate, reqInTime),
      outtTime: Util.convertTZ(reqDate, reqOutTime),
      location: weekOffCheckedBox ? 'WO' : checkedBox ? 'CH' : compOffCheckedBox ? 'CO' : data.location.code,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      isClientHoliday: checkedBox ? true : false,
      isWeekOff: weekOffCheckedBox ? true : false,
      isRegularize: checkedBox ? false : true,
      isCompOff: compOffCheckedBox ? true : false

    };
    const workingTimeCalcDiff = Util.attendanceHrdDiff(obj.inTime, obj.outTime);
    if (Util.convertHoursIntoMin(workingTimeCalcDiff) > Util.convertHoursIntoMin(workingHours.HOURS)) {
      toast.error("Working hrs should not greater than 14:00 hrs!")
    } else {
      attendanceApi.createAttendanceRequest(obj).then(resp => {
        if (resp.data.success === true) {
          toast.success(resp.data.message);
          fetchMissingUserAttendance();
        } else {
          toast.error(resp.data.error)
        }
        setShowNewForm(false);
      });
    }
  }

  const changeHolidayCheckbox = (e) => {
    formik.setFieldValue('inTime', '');
    formik.setFieldValue('outTime', '');
    setCheckedBox(e.checked);
  }
  const changeWeekOffCheckbox = (e) => {
    formik.setFieldValue('inTime', '');
    formik.setFieldValue('outTime', '');
    setWeekOffCheckedBox(e.checked);
  }
  const changeCompOffCheckbox = (e) => {
    formik.setFieldValue('inTime', '');
    formik.setFieldValue('outTime', '');
    setcompOffCheckedBox(e.checked)
  }

  return (
    <div className="dashboard">
      <div className="p-grid">
        <div className="col-12">
          <h1>
            My Action
            <a
              href="#"
              className="m-link ml-4"
              onClick={() => navigate("/my-action")}
            >
              <small style={{ fontSize: "9px", margin: "6px" }}>{empActionList?.pendingApproval?.length > 0 || empActionList?.pendingTimesheet?.length > 0 ? "View All" : ""}</small>
            </a>
          </h1>
          {empActionList?.pendingApproval?.length > 0 || empActionList?.pendingTimesheet?.length > 0 ?
            <ActionCards actionList={empActionList} role="employee" /> :
            <div className="ess-act-card ess-card-theam-4">
              <div className="ess-act-body mt-0 no-header p-3">
                <strong>You have No Pending Actions!</strong>
              </div>
            </div>}
        </div>
      </div>

      {user?.LegalEntity?.code === 'ESIN' && (
        <div className="p-grid">
          <div className="col-12">
            <div>
              <h1 style={{ overflow: "auto" }}>Missing Leaves</h1>
            </div>
            <div className="grid project-allocation">
              <div className="col">
                <div className="ess-act-card ess-card-theam-4">
                  <div className="ess-act-body mt-0 no-header p-3">
                    <div className="missing-attendance-dates">
                      <ul>
                        {missingUserAttendanceList.map(e => <li className={"D-Thu"} onClick={() => applyMissingLeaveAttendance(moment(e).format('DD-MM-YYYY'))}><span>{moment(e).format('ddd DD-MM-YYYY')}</span></li>)}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      )}


      <div className="p-grid">
        <div className="col-12">
          <div>
            <h1 style={{ overflow: "auto" }}>
              My Allocation
              <a href='#' className='m-link ml-4' onClick={() => navigate('/timeline')}>My Timeline<i className="pi pi-arrow-up-right"></i></a>
            </h1>
          </div>
          <div className="grid project-allocation">
            <div className="col">
              <h3>Ongoing</h3>
              <div className="ess-act-card ess-card-theam-4">
                <div className="ess-act-body mt-0 no-header p-3">
                  <OngoingAllocation />
                </div>
              </div>
            </div>
            <div className="col">
              <h3>Upcoming</h3>
              <div className="ess-act-card ess-card-theam-4">
                <div className="ess-act-body mt-0 no-header p-3">
                  <UpcomingAllocation />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        header={"Request for Regularization " + missingLeaveDate}  //{leaveDay[0]}
        visible={showNewForm1}
        style={{ width: '35vw' }}
        onHide={() => setShowNewForm(false)}
      >
        <form onSubmit={formik.handleSubmit} className="p-fluid p-grid mt-2">
          <div className='mb-3 checkbox_block'>
            <span className='regular_checkbox'>
              <Checkbox
                id="leave"
                name=""
                onChange={e => changeHolidayCheckbox(e)} checked={checkedBox}
                disabled={weekOffCheckedBox || compOffCheckedBox}
              />
              <span style={{ marginLeft: '5px' }}>Client Holiday</span>
            </span>
            <span className='regular_checkbox'>
              <Checkbox
                id="leave"
                name=""
                onChange={e => changeWeekOffCheckbox(e)} checked={weekOffCheckedBox}
                disabled={checkedBox || compOffCheckedBox}
              />
              <span style={{ marginLeft: '5px' }}>Week Off</span>
            </span>
            <span className='regular_checkbox'>
              <Checkbox
                id="leave"
                name=""
                onChange={e => changeCompOffCheckbox(e)} checked={compOffCheckedBox}
                disabled={checkedBox || weekOffCheckedBox}
              />
              <span style={{ marginLeft: '5px' }}>Comp Off</span>
            </span>
          </div>
          <div className="grid mt-1">
            <div className="p-field col-6">
              <label htmlFor="date">Location</label>
              <span>
                <Dropdown
                  options={officeOrHome}
                  name="location"
                  disabled={checkedBox || weekOffCheckedBox || compOffCheckedBox}
                  value={formik.values.location}
                  onChange={formik.handleChange}
                  placeholder="Select your Location" />
              </span>

              {getFormErrorMessage('location')}
            </div>
          </div>
          <div className="grid mt-1">
            <div className="p-field col-6">
              <span>
                <label htmlFor="inTime">In Time</label>
                <Calendar
                  keyfilter="time"
                  id="inTime"
                  name="inTime"
                  value={formik.values.inTime}
                  timeOnly hourFormat="24"
                  showSeconds
                  disabled={checkedBox || weekOffCheckedBox || compOffCheckedBox}
                  maxDate={new Date(formik.values.outTime)}
                  onChange={formik.handleChange}
                />
              </span>
              {getFormErrorMessage('inTime')}
            </div>

            <div className="p-field col-6">
              <span>
                <label htmlFor="outTime">Out Time</label>
                <Calendar
                  keyfilter="int"
                  id="outTime"
                  name="outTime"
                  value={formik.values.outTime}
                  timeOnly hourFormat="24"
                  disabled={checkedBox || weekOffCheckedBox || compOffCheckedBox}
                  showSeconds
                  minDate={new Date(formik.values.inTime)}
                  onChange={formik.handleChange}
                />
              </span>
              {getFormErrorMessage('outTime')}
            </div>
          </div>
          <div className="p-field">
            <span>
              <label htmlFor="reason">Reason</label>
              <Dropdown
                id="reason"
                name="reason"
                disabled={checkedBox || weekOffCheckedBox || compOffCheckedBox}
                value={formik.values.reason}
                options={yourDropdownOptionsArray}
                onChange={formik.handleChange}
                className={classNames({ "p-invalid": isFormFieldValid("reason") })}
                placeholder="Select a reason"
              />
            </span>
            {getFormErrorMessage('reason')}
          </div>
          <div className='pt-3'>
            <div className='trxt-right'>
              <div>
                <Button
                  type="button"
                  label="Cancel"
                  className="p-button-rounded p-default"
                  onClick={() => setShowNewForm(false)} 
                />
                <Button
                  type="submit"
                  label="Submit"
                  className="p-button-rounded"
                />
              </div>
            </div>
          </div>
        </form>
      </Dialog>
    </div>
  );
};

export default EmployeeDashboard;